import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-member',
  templateUrl: './event-member.component.html',
  styleUrls: ['./event-member.component.scss']
})
export class EventMemberComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
